import { action } from 'mobx';
import { Observer } from 'mobx-react-lite';
import moment from 'moment';
import React from 'react';
import { CLOCK } from '../../controllers/util-level/clock.controller';
import { useProps, useStore } from '../../utils/mobx.utils';
import { YYYYMMDD } from '../../utils/time.utils';
import BaseButton from '../BaseButton/BaseButton';
import './TimeframePicker.scss';
var TimeframePicker = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get startDateMoment() {
            return moment(p.startDate);
        },
        get endDateMoment() {
            return moment(p.startDate).add(s.unitsPerView - 1, s.unit).endOf(s.unit);
        },
        get monthTitle() {
            switch (p.unit) {
                case 'day':
                case 'days': return s.startDateMoment.format('MMMM D,');
                case 'week':
                case 'weeks': {
                    if (s.startDateMoment.isSame(s.endDateMoment, 'month')) {
                        return s.startDateMoment.format('MMMM D') + "\u2013" + s.endDateMoment.format('D,');
                    }
                    else {
                        return s.startDateMoment.format('MMMM D') + "\u2013" + s.endDateMoment.format('MMMM D,');
                    }
                }
                case 'month':
                case 'months': return s.startDateMoment.format('MMMM');
                default: return undefined;
            }
        },
        get year() {
            return s.startDateMoment.year();
        },
        get unitsPerView() {
            return p.unitsPerView || 1;
        },
        get unit() {
            return p.unit || 'month';
        },
        navigate: action(function (count) {
            if (count === void 0) { count = 1; }
            var newStartDate = moment(p.startDate).add(count, p.unit || 'days').format(YYYYMMDD);
            p.onNavigate && p.onNavigate(newStartDate);
        }),
        get isCurrentWeek() {
            return s.startDateMoment.isSame(CLOCK.localNowMoment, 'week');
        }
    }); });
    var goBack = function () { return s.navigate(s.unitsPerView * -1); };
    var goForward = function () { return s.navigate(s.unitsPerView); };
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: "TimeframePicker" },
            React.createElement(BaseButton, { className: "TimeframePickerNavButton --back subtle", icon: p.icon === 'chevron' ? 'chevron-left' : 'back', onClick: goBack, iconVariant: p.iconVariant, disabled: p.canNotNavigateToPast && s.isCurrentWeek }),
            React.createElement("h2", { className: "TimeframePickerTitle" },
                s.monthTitle && React.createElement(React.Fragment, null,
                    React.createElement("strong", null, s.monthTitle)),
                " ",
                React.createElement("span", null, s.year)),
            React.createElement(BaseButton, { className: "TimeframePickerNavButton --forward subtle", icon: p.icon === 'chevron' ? 'chevron-right' : 'arrow', onClick: goForward, iconVariant: p.iconVariant }))); } });
};
export default TimeframePicker;
